import { Fragment, useEffect, useState, useRef } from 'react';
import './DataGridSizeComparer.css';
import {
	GenerateGridSizeComparerDataGrids,
	GetCampaign,
	GetCampaignGridSizeComparerReportDetails,
	GetCampaignGridSizeComparerReports,
	GetCampaignKeywords,
	GetReportSettings
} from '../../Services';
import ModalDialog from '../../components/modalDialog/ModalDialog';
import ModalDialogContent from '../../components/modalDialog/modalDialogContent/ModalDialogContent';
import ModalDialogButtons from '../../components/modalDialog/modalDialogButtons/ModalDialogButtons';
import { toast } from 'react-toastify';
import { slugify } from '../../utils/Common';
import GridMapV5 from '../../components/gridReport/v5/gridMap/GridMapV5';
import Spinner from '../../components/spinner/Spinner';

const DataGridSizeComparer = ({ campaign, onSave, onClose }) => {
	const [ isLoading, setIsLoading ] = useState(false);
	const [ isGenerating, setIsGenerating ] = useState(false);
	const [ isLoadingMap, setIsLoadingMap ] = useState(false);
	const [ showRadiusPreview, setShowRadiusPreview ] = useState(false);
	const [ keywordObjects, setKeywordObjects ] = useState([]);
	const [ reportsHistory, setReportsHistory ] = useState([]);
	const [ areaRadius, setAreaRadius ] = useState(5);
	const [ mapPreviewGridData, setMapPreviewGridData ] = useState();
	const [ radiuses, setRadiuses ] = useState([
		// { value: 0.5, gridPoints: 11, checked: false },
		{ value: 1, gridPoints: 7, checked: false },
		// { value: 1.5, gridPoints: 11, checked: false },
		{ value: 2, gridPoints: 7, checked: false },
		// { value: 2.5, gridPoints: 11, checked: false },
		{ value: 3, gridPoints: 7, checked: false },
		// { value: 3.5, gridPoints: 11, checked: false },
		{ value: 4, gridPoints: 7, checked: false },
		// { value: 4.5, gridPoints: 11, checked: false },
		{ value: 5, gridPoints: 9, checked: false },
		// { value: 5.5, gridPoints: 11, checked: false },
		{ value: 6, gridPoints: 9, checked: false },
		// { value: 6.5, gridPoints: 11, checked: false },
		{ value: 7, gridPoints: 9, checked: false },
		// { value: 7.5, gridPoints: 11, checked: false },
		{ value: 8, gridPoints: 9, checked: false },
		// { value: 8.5, gridPoints: 11, checked: false },
		{ value: 9, gridPoints: 9, checked: false },
		// { value: 9.5, gridPoints: 11, checked: false },
		{ value: 10, gridPoints: 11, checked: false },
		// { value: 10.5, gridPoints: 11, checked: false },
		{ value: 11, gridPoints: 11, checked: false },
		// { value: 11.5, gridPoints: 11, checked: false },
		{ value: 12, gridPoints: 11, checked: false },
		// { value: 12.5, gridPoints: 11, checked: false },
		{ value: 13, gridPoints: 11, checked: false },
		// { value: 13.5, gridPoints: 11, checked: false },
		{ value: 14, gridPoints: 11, checked: false },
		// { value: 14.5, gridPoints: 11, checked: false },
		{ value: 15, gridPoints: 11, checked: false }
	]);
	const [ dataGridResponse, setDataGridResponse ] = useState();
	const [ reportSettingsFormData, setReportSettingsFormData ] = useState({});

	useEffect(
		() => {
			if (campaign) {
				getReportSettings();
				getCampaignKeywords();
				getReportsHistory();

				setMapPreviewGridData({
					googlePlaceId : campaign.googlePlaceId,
					lat           : campaign.lat,
					lng           : campaign.lng
				});
			}
		},
		[ campaign ]
	);

	const getCampaignKeywords = async () => {
		setIsLoading(true);

		const response = await GetCampaignKeywords(campaign.id);

		if (response) {
			let tempKeywords = response;

			tempKeywords = tempKeywords.sort(function(a, b) {
				return a.orderIndex - b.orderIndex;
			});

			for (let i = 0; i < tempKeywords.length; i++) {
				tempKeywords[i].index = i;
				tempKeywords[i].checked = false;
			}

			setKeywordObjects(tempKeywords);
		}

		setIsLoading(false);
	};

	const getReportsHistory = async () => {
		setIsLoading(true);

		const response = await GetCampaignGridSizeComparerReports(campaign.id);

		if (response) {
			let tempReportsHistory = response.reports || [];

			tempReportsHistory = tempReportsHistory.sort(function(a, b) {
				return new Date(b.dateCreated) - new Date(a.dateCreated);
			});

			setReportsHistory(tempReportsHistory);
		}

		setIsLoading(false);
	};

	const getReportSettings = async () => {
		let response = await GetReportSettings();

		if (response && response.data) {
			setReportSettingsFormData(response.data);
		}
	};

	const handleCloseDialog = () => {
		if (onClose) {
			onClose();
		}
	};

	const handleSave = () => {
		if (onSave) {
			onSave();
		}
	};

	const handleSelectAllKeywordsChange = async (e) => {
		const { checked } = e.target;
		let tempKeywords = [ ...keywordObjects ];

		tempKeywords.forEach((item) => {
			item.checked = checked;
		});

		setKeywordObjects(tempKeywords);
	};

	const handleKeywordSelectionChange = async (e) => {
		const { name, checked } = e.target;

		let kwId = name.replace('chkKeyword_', '');
		let tempKeywordObjects = [ ...keywordObjects ];

		let item = tempKeywordObjects.find((x) => x.id === kwId);

		if (item) {
			item.checked = checked;
		}

		setKeywordObjects(tempKeywordObjects);
	};

	const handleSelectAllRadiusesChange = async (e) => {
		const { checked } = e.target;
		let tempRadiuses = [ ...radiuses ];

		tempRadiuses.forEach((item) => {
			item.checked = checked;
		});

		setRadiuses(tempRadiuses);
	};

	const handleRadiusSelectionChange = async (e) => {
		const { name, checked } = e.target;

		let rValue = name.replace('chkRadius_', '');
		let tempRadiuses = [ ...radiuses ];

		let item = tempRadiuses.find((x) => x.value === parseFloat(rValue));

		if (item) {
			item.checked = checked;
		}

		setRadiuses(tempRadiuses);
	};

	const generateDataGrids = async () => {
		let selectedKeywords = keywordObjects.filter((x) => x.checked);
		let selectedRadiuses = radiuses.filter((x) => x.checked);

		if (!selectedKeywords || selectedKeywords.length === 0) {
			toast.error('You have to select at least one keyword.');
			return;
		}

		if (!selectedRadiuses || selectedRadiuses.length === 0) {
			toast.error('You have to select at least one radius.');
			return;
		}

		setDataGridResponse();
		setIsGenerating(true);
		setIsLoadingMap(true);

		let keywords = selectedKeywords.map((x) => x.keyword);

		let data = {
			campaignId : campaign.id,
			keywords   : keywords,
			radiuses   : selectedRadiuses
		};

		const response = await GenerateGridSizeComparerDataGrids(data);

		if (response.success) {
			if (response.data && response.data.length) {
				//adjust response struv=cture for displaying grids
				let tempDataGridResponse = [];

				keywords.forEach((keyword) => {
					let kwGridData = {
						keyword : keyword,
						data    : []
					};

					response.data.forEach((responseDataItem) => {
						let currentKwGridData = responseDataItem.gridResponse.data.find((x) => x.keyword === keyword);

						let gridData = {
							radius        : responseDataItem.radius,
							gridPoints    : responseDataItem.gridPoints,
							pointDistance : responseDataItem.pointDistance,
							grid          : {
								...responseDataItem.gridResponse,
								...currentKwGridData
							}
						};

						delete gridData.grid.data;

						kwGridData.data.push(gridData);
					});

					tempDataGridResponse.push(kwGridData);
				});

				setDataGridResponse(tempDataGridResponse);
				setShowRadiusPreview(false);
			}
		}

		setIsGenerating(false);
		setIsLoadingMap(false);
	};

	const saveDataGridSettings = () => {};

	const handleViewReport = async (reportName) => {
		setIsLoadingMap(true);
		const response = await GetCampaignGridSizeComparerReportDetails(campaign.id, reportName);

		if (response.success) {
			if (response.data && response.data.length) {
				//adjust response structure for displaying grids
				let tempDataGridResponse = [];

				let selectedKeywords = response.data[0].gridResponse.data.map((x) => x.keyword);

				selectedKeywords.forEach((keyword) => {
					let kwGridData = {
						keyword : keyword,
						data    : []
					};

					response.data.forEach((responseDataItem) => {
						let currentKwGridData = responseDataItem.gridResponse.data.find((x) => x.keyword === keyword);

						let gridData = {
							radius        : responseDataItem.radius,
							gridPoints    : responseDataItem.gridPoints,
							pointDistance : responseDataItem.pointDistance,
							grid          : {
								...responseDataItem.gridResponse,
								...currentKwGridData
							}
						};

						delete gridData.grid.data;

						kwGridData.data.push(gridData);
					});

					tempDataGridResponse.push(kwGridData);
				});

				setDataGridResponse(tempDataGridResponse);
				setShowRadiusPreview(false);
			}
		}

		setIsLoadingMap(false);
	};

	const toggleRadiusMapPreview = () => {
		setShowRadiusPreview(!showRadiusPreview);
	};

	const handleCircleMove = (center) => {
		if (center) {
			setMapPreviewGridData({
				...mapPreviewGridData,
				lat : center.lat,
				lng : center.lng
			});
		}
	};

	return (
		<ModalDialog position="right-sidebar large">
			<ModalDialogContent align="start">
				<div className="container-fluid grid-size-comparer-container px-0">
					<div className="row mb-3 align-items-start">
						<div className="col-4">
							<label className="form-label">
								<span>Keywords:</span>
								<span className="ms-3">
									<input
										type="checkbox"
										className="form-check-input"
										name="chkAllKeywords"
										id="chkAllKeywords"
										onChange={handleSelectAllKeywordsChange}
										disabled={isGenerating || isLoadingMap}
									/>
									<label htmlFor="chkAllKeywords" className="form-check-label w-auto ms-1">
										All
									</label>
								</span>
							</label>
							<div className="keywords-wrapper">
								{keywordObjects &&
								keywordObjects.length && (
									<Fragment>
										{keywordObjects.map((item, index) => {
											let isKwSelected =
												keywordObjects &&
												keywordObjects.length &&
												keywordObjects.find((x) => x.id === item.id).checked;

											return (
												<div className="form-check" key={index}>
													<input
														type="checkbox"
														className="form-check-input"
														name={`chkKeyword_${item.id}`}
														id={`chkKeyword_${item.id}`}
														value={item.keyword}
														onChange={handleKeywordSelectionChange}
														checked={isKwSelected}
														disabled={isGenerating || isLoadingMap}
													/>
													<label
														htmlFor={`chkKeyword_${item.id}`}
														className="form-check-label w-auto me-2"
													>
														{item.keyword}
													</label>
												</div>
											);
										})}
									</Fragment>
								)}
							</div>
						</div>

						<div className="col-4">
							<label className="form-label">
								<span>Radius (miles):</span>
								<span className="ms-3">
									<input
										type="checkbox"
										className="form-check-input"
										name="chkAllRadiuses"
										id="chkAllRadiuses"
										onChange={handleSelectAllRadiusesChange}
										disabled={isGenerating || isLoadingMap}
									/>
									<label htmlFor="chkAllRadiuses" className="form-check-label w-auto ms-1">
										All
									</label>
								</span>
							</label>
							<div className="keywords-wrapper">
								{radiuses.map((item, index) => {
									let isSelected = radiuses.find((x) => x.value === item.value).checked;

									return (
										<div className="form-check" key={index}>
											<input
												type="checkbox"
												className="form-check-input"
												name={`chkRadius_${item.value}`}
												id={`chkRadius_${item.value}`}
												value={item.value}
												onChange={handleRadiusSelectionChange}
												checked={isSelected}
												disabled={isGenerating || isLoadingMap}
											/>
											<label
												htmlFor={`chkRadius_${item.value}`}
												className="form-check-label w-auto me-2"
											>
												{item.value}
											</label>
										</div>
									);
								})}
							</div>
						</div>

						<div className="col-4">
							<label className="form-label d-block">
								<span>History:</span>
								<span className="float-end">
									<button
										className="btn btn-primary map-radius-preview-button"
										onClick={toggleRadiusMapPreview}
									>
										{showRadiusPreview ? 'Hide Preview' : 'Open Preview'}
									</button>
								</span>
							</label>
							<div className="keywords-wrapper">
								{reportsHistory &&
								reportsHistory.length > 0 && (
									<div className="report-history-wrapper">
										{reportsHistory.map((report, index) => (
											<div className="report-history-item mb-1" key={index}>
												<span>{report.name}</span>
												<span className="float-end">
													<button
														className="btn btn-link p-0 ms-4"
														onClick={() => handleViewReport(report.name)}
														disabled={isGenerating || isLoadingMap}
													>
														View
													</button>
												</span>
											</div>
										))}
									</div>
								)}
							</div>
						</div>
					</div>

					{showRadiusPreview ? (
						<div className="row align-items-start">
							<div className="col-auto me-2">
								<label className="form-label">Service Area Radius:</label>
							</div>
							<div className="col-4">
								<input
									type="range"
									name="areaRadius"
									className="form-range"
									value={areaRadius || ''}
									onChange={(e) => setAreaRadius(e.target.value)}
									min={1}
									max={15}
									step={1}
									disabled={isGenerating || isLoadingMap}
								/>
							</div>
							<div className="col-auto">
								<span className="area-radius-value">{`${areaRadius || ''} miles`}</span>
							</div>

							{/* map */}
							<div className="col-12">
								{(!mapPreviewGridData || isGenerating || isLoadingMap) && (
									<div className="loading-map">
										<Spinner />
									</div>
								)}

								{mapPreviewGridData && (
									<GridMapV5
										key="map-preview"
										mapIdValue="report-map-preview"
										gridData={mapPreviewGridData}
										placeId={campaign.googlePlaceId}
										showCircle={true}
										circleRadius={areaRadius}
										onCircleMove={handleCircleMove}
										reportSettings={reportSettingsFormData}
										isPreview={true}
										fixedHeight={400}
									/>
								)}
							</div>
						</div>
					) : (
						<Fragment>
							<div className="row align-items-start position-relative">
								<div className="col-12">
									{isLoadingMap && (
										<div className="loading-map">
											<Spinner />
										</div>
									)}

									{dataGridResponse &&
									dataGridResponse.length && (
										<Fragment>
											<ul
												className="nav nav-tabs"
												id="tabDataGridComparerKeywords"
												role="tablist"
											>
												{dataGridResponse.map((kwGridData, index) => {
													let kwSlug = slugify(kwGridData.keyword);

													return (
														<li className="nav-item" role="presentation" key={index}>
															<button
																className={`nav-link ${index === 0 ? 'active' : ''}`}
																id={`${kwSlug}-tab`}
																data-bs-toggle="tab"
																data-bs-target={`#${kwSlug}-tab-pane`}
																type="button"
																role="tab"
																aria-controls={`${kwSlug}-tab-pane`}
																aria-selected={index === 0 ? 'true' : 'false'}
															>
																{kwGridData.keyword}
															</button>
														</li>
													);
												})}
											</ul>
											<div
												className="tab-content border grid-size-comparer-content"
												id="tabDataGridComparerKeywordsContent"
											>
												{dataGridResponse.map((kwGridData, index) => {
													let kwSlug = slugify(kwGridData.keyword);

													return (
														<div
															className={`tab-pane fade ${index === 0
																? 'show active'
																: ''}`}
															id={`${kwSlug}-tab-pane`}
															key={index}
															role="tabpanel"
															aria-labelledby={`${kwSlug}-tab`}
															tabIndex={index}
														>
															<div className="p-3 campaign-v-p-report-v5">
																{kwGridData.data &&
																kwGridData.data.length > 0 && (
																	<Fragment>
																		{kwGridData.data.map(
																			(radiusGridData, radiusGridIndex) => (
																				<div
																					className="map-wrapper mb-3"
																					key={radiusGridIndex}
																				>
																					<div className="text-start mb-1">
																						<span
																						>{`Radius: ${radiusGridData.radius} miles`}</span>
																						<span className="ms-4">{`Points: ${radiusGridData.gridPoints}`}</span>
																						<span className="ms-4">{`Point Distance: ${radiusGridData.pointDistance} miles`}</span>
																					</div>
																					<GridMapV5
																						key={`map-${radiusGridIndex}`}
																						gridData={radiusGridData.grid}
																						placeId={campaign.googlePlaceId}
																						placeCid={campaign.googleCid}
																						isFullScreen={false}
																						reportSettings={
																							reportSettingsFormData
																						}
																					/>
																				</div>
																			)
																		)}
																	</Fragment>
																)}
															</div>
														</div>
													);
												})}
											</div>
										</Fragment>
									)}
								</div>
							</div>
						</Fragment>
					)}
				</div>
			</ModalDialogContent>
			<ModalDialogButtons>
				<button className="btn btn-primary" onClick={generateDataGrids} disabled={isGenerating || isLoadingMap}>
					{isGenerating ? (
						<Fragment>
							<span className="spinner-border m-0 me-2" />
							<span>Generating Grids...</span>
						</Fragment>
					) : (
						<span>Generate Grids</span>
					)}
				</button>

				<button className="btn btn-outline-primary" onClick={handleCloseDialog}>
					<span>Close</span>
				</button>
			</ModalDialogButtons>
		</ModalDialog>
	);
};

export default DataGridSizeComparer;
